import { render, staticRenderFns } from "./TermPolicyModal.vue?vue&type=template&id=e06fd812&"
import script from "./TermPolicyModal.vue?vue&type=script&lang=js&"
export * from "./TermPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./TermPolicyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports